"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = unsubscribeAll;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _unsubscribe = require("./unsubscribe");

var _unsubscribe2 = _interopRequireDefault(_unsubscribe);

function unsubscribeAll(state) {
  var firebaseRefs = state.firebaseRefs;

  Object.keys(firebaseRefs).forEach(function (localBinding) {
    if (firebaseRefs.hasOwnProperty(localBinding)) {
      (0, _unsubscribe2["default"])(state)(localBinding);
    }
  });
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/refire/lib/syncFirebase/unsubscribeAll.js
// module id = 1003
// module chunks = 0